import "./style.scss"

import React from "react"
import { Loader as CheckoutLoader } from "tf-checkout-react"

export const Loader = ({ loading = true }) => {
  if (!loading) return null

  return (
    <div className="page-loading">
      <CheckoutLoader className="page-loading__spinner" />
    </div>
  )
}
